import {Component, input} from '@angular/core';
import {TableModule} from 'primeng/table';

@Component({
  selector: 'app-progress-dashboard-container',
  imports: [TableModule],
  templateUrl: './progress-dashboard-container.component.html',
})
export class ProgressDashboardContainerComponent {
  readonly label = input.required<string>();
}
